export var QaCaseStatus;
(function (QaCaseStatus) {
    QaCaseStatus["PENDING_ASSIGNMENT"] = "PENDING_ASSIGNMENT";
    QaCaseStatus["IN_REVIEW"] = "IN_REVIEW";
    QaCaseStatus["READY_TO_FINALIZE"] = "READY_TO_FINALIZE";
    QaCaseStatus["AWAITING_ACKNOWLEDGEMENT"] = "AWAITING_ACKNOWLEDGEMENT";
    QaCaseStatus["CLOSED_ACKNOWLEDGED"] = "CLOSED_ACKNOWLEDGED";
    QaCaseStatus["CLOSED_UNACKNOWLEDGED"] = "CLOSED_UNACKNOWLEDGED";
    QaCaseStatus["DISPUTED"] = "DISPUTED";
    QaCaseStatus["CLOSED_RESOLVED"] = "CLOSED_RESOLVED";
    QaCaseStatus["CANCELLED"] = "CANCELLED";
})(QaCaseStatus || (QaCaseStatus = {}));
export var QaAssignmentStatus;
(function (QaAssignmentStatus) {
    QaAssignmentStatus["ASSIGNED"] = "ASSIGNED";
    QaAssignmentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    QaAssignmentStatus["SUBMITTED"] = "SUBMITTED";
    QaAssignmentStatus["WAIVED"] = "WAIVED";
    QaAssignmentStatus["REASSIGNED"] = "REASSIGNED";
})(QaAssignmentStatus || (QaAssignmentStatus = {}));
export var QaScorecardVersionStatus;
(function (QaScorecardVersionStatus) {
    QaScorecardVersionStatus["DRAFT"] = "DRAFT";
    QaScorecardVersionStatus["SCHEDULED"] = "SCHEDULED";
    QaScorecardVersionStatus["PUBLISHED"] = "PUBLISHED";
    QaScorecardVersionStatus["ARCHIVED"] = "ARCHIVED";
})(QaScorecardVersionStatus || (QaScorecardVersionStatus = {}));
export var QaRuleRevisionStatus;
(function (QaRuleRevisionStatus) {
    QaRuleRevisionStatus["DRAFT"] = "DRAFT";
    QaRuleRevisionStatus["SCHEDULED"] = "SCHEDULED";
    QaRuleRevisionStatus["ACTIVE"] = "ACTIVE";
    QaRuleRevisionStatus["SUPERSEDED"] = "SUPERSEDED";
    QaRuleRevisionStatus["INACTIVE"] = "INACTIVE";
})(QaRuleRevisionStatus || (QaRuleRevisionStatus = {}));
export var QaMeasurementPeriod;
(function (QaMeasurementPeriod) {
    QaMeasurementPeriod["DAILY"] = "DAILY";
    QaMeasurementPeriod["WEEKLY"] = "WEEKLY";
    QaMeasurementPeriod["MONTHLY"] = "MONTHLY";
})(QaMeasurementPeriod || (QaMeasurementPeriod = {}));
export var QaSelectionSchedule;
(function (QaSelectionSchedule) {
    QaSelectionSchedule["DAILY_AT_02_00"] = "DAILY_AT_02_00";
    QaSelectionSchedule["WEEKLY_MONDAY_AT_02_00"] = "WEEKLY_MONDAY_AT_02_00";
    QaSelectionSchedule["MONTHLY_FIRST_AT_02_00"] = "MONTHLY_FIRST_AT_02_00";
})(QaSelectionSchedule || (QaSelectionSchedule = {}));
export var QaReviewerRole;
(function (QaReviewerRole) {
    QaReviewerRole["OFFICIAL"] = "OFFICIAL";
    QaReviewerRole["AGENT"] = "AGENT";
    QaReviewerRole["TEAM_LEADER"] = "TEAM_LEADER";
    QaReviewerRole["QA_MANAGER"] = "QA_MANAGER";
})(QaReviewerRole || (QaReviewerRole = {}));
export var QaAnswer;
(function (QaAnswer) {
    QaAnswer["YES"] = "YES";
    QaAnswer["NO"] = "NO";
    QaAnswer["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(QaAnswer || (QaAnswer = {}));
export var QaPassStatus;
(function (QaPassStatus) {
    QaPassStatus["PASSED"] = "PASSED";
    QaPassStatus["FAILED"] = "FAILED";
    QaPassStatus["UNSCORABLE"] = "UNSCORABLE";
})(QaPassStatus || (QaPassStatus = {}));
export var QaComplianceStatus;
(function (QaComplianceStatus) {
    QaComplianceStatus["PASSED"] = "PASSED";
    QaComplianceStatus["FAILED"] = "FAILED";
})(QaComplianceStatus || (QaComplianceStatus = {}));
export var QaSelectionSource;
(function (QaSelectionSource) {
    QaSelectionSource["RANDOM"] = "RANDOM";
    QaSelectionSource["TARGETED"] = "TARGETED";
})(QaSelectionSource || (QaSelectionSource = {}));
export var QaTargetedSelectionRejectionCode;
(function (QaTargetedSelectionRejectionCode) {
    QaTargetedSelectionRejectionCode["DUPLICATE"] = "DUPLICATE";
    QaTargetedSelectionRejectionCode["CALL_INELIGIBLE"] = "CALL_INELIGIBLE";
    QaTargetedSelectionRejectionCode["RECORDING_UNAVAILABLE"] = "RECORDING_UNAVAILABLE";
    QaTargetedSelectionRejectionCode["FORBIDDEN"] = "FORBIDDEN";
})(QaTargetedSelectionRejectionCode || (QaTargetedSelectionRejectionCode = {}));
export var QaErrorCode;
(function (QaErrorCode) {
    QaErrorCode["NOT_IMPLEMENTED"] = "QA_NOT_IMPLEMENTED";
    QaErrorCode["INVALID_TRANSITION"] = "QA_INVALID_TRANSITION";
    QaErrorCode["RULE_CONFLICT"] = "QA_RULE_CONFLICT";
    QaErrorCode["FORBIDDEN"] = "QA_FORBIDDEN";
    QaErrorCode["INVALID_SCORECARD"] = "QA_INVALID_SCORECARD";
    QaErrorCode["INVALID_ASSIGNMENT"] = "QA_INVALID_ASSIGNMENT";
    QaErrorCode["INVALID_QUOTA"] = "QA_INVALID_QUOTA";
    QaErrorCode["INVALID_DEADLINE"] = "QA_INVALID_DEADLINE";
    QaErrorCode["INVALID_RECONCILIATION"] = "QA_INVALID_RECONCILIATION";
    QaErrorCode["INVALID_DISPUTE"] = "QA_INVALID_DISPUTE";
})(QaErrorCode || (QaErrorCode = {}));
export var QaCaseCommand;
(function (QaCaseCommand) {
    QaCaseCommand["ASSIGN"] = "ASSIGN";
    QaCaseCommand["MARK_READY"] = "MARK_READY";
    QaCaseCommand["REOPEN_REVIEW"] = "REOPEN_REVIEW";
    QaCaseCommand["FINALIZE"] = "FINALIZE";
    QaCaseCommand["REOPEN_FINALIZATION"] = "REOPEN_FINALIZATION";
    QaCaseCommand["CLOSE_ACKNOWLEDGED"] = "CLOSE_ACKNOWLEDGED";
    QaCaseCommand["CLOSE_UNACKNOWLEDGED"] = "CLOSE_UNACKNOWLEDGED";
    QaCaseCommand["DISPUTE"] = "DISPUTE";
    QaCaseCommand["RESOLVE_DISPUTE"] = "RESOLVE_DISPUTE";
    QaCaseCommand["REVISE_RESULT"] = "REVISE_RESULT";
    QaCaseCommand["CANCEL"] = "CANCEL";
})(QaCaseCommand || (QaCaseCommand = {}));
export var QaDisputeResolutionAction;
(function (QaDisputeResolutionAction) {
    QaDisputeResolutionAction["UPHOLD"] = "UPHOLD";
    QaDisputeResolutionAction["REVISE_RESULT"] = "REVISE_RESULT";
    QaDisputeResolutionAction["REQUEST_REASSESSMENT"] = "REQUEST_REASSESSMENT";
    QaDisputeResolutionAction["REOPEN_FINALIZATION"] = "REOPEN_FINALIZATION";
})(QaDisputeResolutionAction || (QaDisputeResolutionAction = {}));
export var QaAssignmentCommandType;
(function (QaAssignmentCommandType) {
    QaAssignmentCommandType["START"] = "START";
    QaAssignmentCommandType["SUBMIT"] = "SUBMIT";
    QaAssignmentCommandType["WAIVE"] = "WAIVE";
    QaAssignmentCommandType["REASSIGN"] = "REASSIGN";
    QaAssignmentCommandType["REOPEN"] = "REOPEN";
})(QaAssignmentCommandType || (QaAssignmentCommandType = {}));
export var QaDeadlineKind;
(function (QaDeadlineKind) {
    QaDeadlineKind["REVIEWER"] = "REVIEWER";
    QaDeadlineKind["FINALIZER"] = "FINALIZER";
    QaDeadlineKind["ACKNOWLEDGEMENT"] = "ACKNOWLEDGEMENT";
})(QaDeadlineKind || (QaDeadlineKind = {}));
export var QaPermission;
(function (QaPermission) {
    QaPermission["REVIEW"] = "QA.review";
    QaPermission["FINALIZE"] = "QA.finalize";
    QaPermission["VIEW_TEAM"] = "QA.viewTeam";
    QaPermission["VIEW_ORGANIZATION"] = "QA.viewOrganization";
    QaPermission["LIST_RECORDINGS"] = "Recording.list";
})(QaPermission || (QaPermission = {}));
export var QaAction;
(function (QaAction) {
    QaAction["REVIEW_CASE"] = "REVIEW_CASE";
    QaAction["FINALIZE_CASE"] = "FINALIZE_CASE";
    QaAction["VIEW_RESULT"] = "VIEW_RESULT";
    QaAction["VIEW_CASE"] = "VIEW_CASE";
    QaAction["PLAY_RECORDING"] = "PLAY_RECORDING";
})(QaAction || (QaAction = {}));
export var QaVisibilityActor;
(function (QaVisibilityActor) {
    QaVisibilityActor["REVIEWER"] = "REVIEWER";
    QaVisibilityActor["FINALIZER"] = "FINALIZER";
    QaVisibilityActor["EVALUATED_AGENT"] = "EVALUATED_AGENT";
    QaVisibilityActor["ORGANIZATION_OPERATIONS"] = "ORGANIZATION_OPERATIONS";
})(QaVisibilityActor || (QaVisibilityActor = {}));
export var QaVisibilityScope;
(function (QaVisibilityScope) {
    QaVisibilityScope["NONE"] = "NONE";
    QaVisibilityScope["OWN"] = "OWN";
    QaVisibilityScope["ALL"] = "ALL";
})(QaVisibilityScope || (QaVisibilityScope = {}));
